import extend from 'lodash/extend';

import Observable from '../../lib/ObservableMixin.js';

export default class ChatGatewayBase {
  auth() {
    throw new Error('auth function is not implemented');
  }

  configureProvider() {
    throw new Error('configureProvider function is not implemented');
  }

  handleAuthenticatedSuccess() {
    throw new Error('handleAuthenticatedSuccess function is not implemented');
  }

  handleAuthenticatedError() {
    throw new Error('handleAuthenticatedError function is not implemented');
  }

  configure({ orgDomain, loginDomain, appId }) {
    this.orgDomain = orgDomain;
    this.loginDomain = loginDomain;
    this.appId = appId;
  }

  reconnect() {
    throw new Error('reconnect function is not implemented');
  }
}

extend(ChatGatewayBase.prototype, Observable);
